import commaUp from '../../../assets/images/solution/anti/comma-up.png'
import commaDown from '../../../assets/images/solution/anti/comma-down.png'
import divide from '../../../assets/images/solution/anti/divide.png'

import './_style.scss'

function SmartAntiSmuggling() {
    return (
        <div className="anti-wrapper">
            <div className="banner">
                <div className="title">智慧缉私</div>
                <div className="content">海关缉私情报研判分析系统充分运用大数据、云计算等先进技术，汇聚公安网、海关网、互联网等多源数据</div>
            </div>
            <div className="introduction-wrapper">
                <p className="title">方案简介</p>
                <div className="introduction-title">
                    <div>
                        <img src={commaUp} alt="" />
                        <p>智慧缉私</p>
                        <p>海关缉私情报研判分析系统充分运用大数据、云计算等先进技术，汇聚公安网、海关网、互联网等多源数据，融合形成缉私情报数据仓库，通过线索发现、情报智判等科技手段，智能发现线索并深度挖掘，为打击走私提供有力支撑。</p>
                        <img src={commaDown} alt="" />
                    </div>
                </div>
            </div>
            <div className="achievement-wrapper">
                <p className="title">典型实践</p>
                <div className="achievement-container">
                    <div className="achievement-item">
                        <p className="title">方案实现</p>
                        <img src={divide} alt="" />
                        <p className="content">目前，产品已在海关总署、深圳、汕头、江门、武汉、郑州、石家庄、青岛、宁波、福州等多地上线使用</p>
                    </div>
                    <div className="achievement-item">
                        <p className="title">案件支撑</p>
                        <img src={divide} alt="" />
                        <p className="content">支撑了全国1000余条缉私案件线索的核查工作</p>
                        <p className="content">协助办理了全国600余起走私案件</p>
                    </div>
                    <div className="achievement-item">
                        <p className="title">实践成果</p>
                        <img src={divide} alt="" />
                        <p className="content">案值超过300亿元</p>
                        <p className="content">共打击重点人员2500余人</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SmartAntiSmuggling